import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import { CarouselNavigationButton } from '../../../../../components/CarouselNavigationButton';
import { VetProfile } from './VetProfile';
import { HtmlIds } from '../../../../../constants';
import { data as vetProfiles } from '../../../../../data/health-vet-profiles';
import { Box, BoxProps } from '../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../wag-react/next-components/Flex';
import { Button } from '../../../../../wag-react/next-components/button';
SwiperCore.use([Navigation]);
const largeScreenSwiperParams = {
  slidesPerView: 1,
  grabCursor: true,
  /**
   * TODO - There seems to be some issue with the images when loop is on.
   * Turning it off makes it respond correctly.
   * No images + loop -> OK
   * Images + no loop -> OK
   * Images + loop -> Not OK
   */
  loop: false,
  loopFillGroupWithBlank: true,
  navigation: {
    nextEl: '.swiper-button-next.meet-the-vets-swiper-button-next',
    prevEl: '.swiper-button-prev.meet-the-vets-swiper-button-prev'
  },
  spaceBetween: 16
};
const smallScreenSwiperParams = {
  freeMode: true,
  slidesPerView: 1.1,
  slidesOffsetBefore: 8,
  spaceBetween: 8,
  width: 350
};
export type MeetTheVetsCarouselProps = BoxProps;

/*
  We can't create a component for the "children" of the <Swiper />
  for some reason with its internal code. Whenever we create
  a component and render it on Swiper's children,
  the CSS classes aren't getting applied.
  In order to work on top of that, we have to iterate here directly
*/

export const MeetTheVetsCarousel = (props: MeetTheVetsCarouselProps) => <>
    <Box position="relative" mt={[0, null, '64px']} px={[0, '48px', '56px']} {...props} data-sentry-element="Box" data-sentry-source-file="MeetTheVetsCarousel.tsx">
      <Box display={['none', 'block']} data-sentry-element="Box" data-sentry-source-file="MeetTheVetsCarousel.tsx">
        <Swiper {...largeScreenSwiperParams} data-sentry-element="Swiper" data-sentry-source-file="MeetTheVetsCarousel.tsx">
          <CarouselNavigationButton variant="prev" prevContainerElemId="meet-the-vets-carousel-swiper-button-prev" iconProps={{
          color: '#727272'
        }} data-sentry-element="CarouselNavigationButton" data-sentry-source-file="MeetTheVetsCarousel.tsx" />
          <CarouselNavigationButton variant="next" nextContainerElemId="meet-the-vets-carousel-swiper-button-next" iconProps={{
          color: '#727272'
        }} data-sentry-element="CarouselNavigationButton" data-sentry-source-file="MeetTheVetsCarousel.tsx" />
          {vetProfiles.map(({
          name,
          degree,
          specialization,
          imageUrl
        }) => <SwiperSlide key={name}>
              <VetProfile value={{
            name,
            degree,
            specializationText: specialization,
            src: imageUrl
          }} />
            </SwiperSlide>)}
        </Swiper>
      </Box>
      <Box display={['block', 'none']} data-sentry-element="Box" data-sentry-source-file="MeetTheVetsCarousel.tsx">
        <Swiper {...smallScreenSwiperParams} data-sentry-element="Swiper" data-sentry-source-file="MeetTheVetsCarousel.tsx">
          {vetProfiles.map(({
          name,
          degree,
          specialization,
          imageUrl
        }) => <SwiperSlide key={name}>
              <VetProfile mt="64px" value={{
            name,
            degree,
            specializationText: specialization,
            src: imageUrl
          }} />
            </SwiperSlide>)}
        </Swiper>
      </Box>
      <Flex display={['flex', null, 'none']} mt="40px" justifyContent="center" data-sentry-element="Flex" data-sentry-source-file="MeetTheVetsCarousel.tsx">
        <Button variant="contained" size="large" href={`#${HtmlIds.VET_CHAT_WIDGET}`} data-sentry-element="Button" data-sentry-source-file="MeetTheVetsCarousel.tsx">
          Connect now
        </Button>
      </Flex>
      <Box display={['none', 'block']} height="auto" className="swiper-button-prev meet-the-vets-swiper-button-prev" id="meet-the-vets-carousel-swiper-button-prev" left={['8px', 0, '8px']} width="auto" data-sentry-element="Box" data-sentry-source-file="MeetTheVetsCarousel.tsx" />
      <Box display={['none', 'block']} height="auto" className="swiper-button-next meet-the-vets-swiper-button-next" id="meet-the-vets-carousel-swiper-button-next" right={['8px', 0, '8px']} width="auto" data-sentry-element="Box" data-sentry-source-file="MeetTheVetsCarousel.tsx" />
    </Box>
    <SwiperGlobalStyle data-sentry-element="SwiperGlobalStyle" data-sentry-source-file="MeetTheVetsCarousel.tsx" />
  </>;
const SwiperGlobalStyle = createGlobalStyle`
  .swiper-button-prev:after {
    display: none;
  }

  .swiper-button-next:after {
    display: none;
  }
`;